export const BEAD = 'bead';
export const BIG = 'big';
export const BIG_EYE = 'bigEye';
export const SMALL = 'small';
export const COCKROACH = 'cockroach';
